import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';
import { useUserDuck } from '@hooks/useUserDuck';

export const usePersonalizedOffer = () => {
    const { currentDeal } = useCarDetailsDuck();

    const { isUserLoggedInAsDealer } = useUserDuck();

    const hasPersonalizedPx = !!currentDeal?.extraFields?.px;

    const isPersonalizedDealByAgent = !!currentDeal?.extraFields?.agentType && !!currentDeal?.endDate;

    return {
        hasPersonalizedPx,
        isPersonalizedDeal: isPersonalizedDealByAgent && !isUserLoggedInAsDealer,
    };
};
